
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-74deaff6&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GridComponent.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./GridComponent.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-74deaff6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./GridComponent.vue"),
  /* scopeId */
  "data-v-74deaff6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GridComponent.vue
// module id = 555
// module chunks = 2